import * as React from 'react';
import { cdnImage } from '@/utils/image-utils';
import GamesCategoryNav from '@/components/shared/games-category-nav/GamesCategoryNav';
import { useState } from 'react';
import classNames from 'classnames';

const ProviderGamesLayout = ({
  provider,
  title,
  subtitle,
  children,
}: {
  provider: string;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <div>
      <div
        className={classNames('relative', {
          'min-h-[300px] bg-luckyBlue2': !imgLoaded,
        })}
      >
        <picture className="w-full h-full object-cover object-right">
          <source
            media="(min-width:768px)"
            srcSet={cdnImage(`banners/jpeg/${provider}_desktop.jpeg`, {
              height: 'auto',
              width: '1920',
              fit: 'contain',
            })}
          />
          <img
            src={cdnImage(`banners/jpeg/${provider}_mobile.jpeg`, {
              height: 'auto',
              width: '768',
              fit: 'contain',
            })}
            alt={imgLoaded ? title : ''}
            onError={() => {
              setImgLoaded(false);
            }}
            onLoad={() => {
              setImgLoaded(true);
            }}
          />
        </picture>
        {title && (
          <div className="absolute top-0 left-0 right-0 bottom-0">
            <div className="max-w-container mx-auto px-4 md:px-8 h-full w-full flex justify-end flex-col pb-8 lg:pb-16">
              <h1 className="text-white mb-2 text-2xl md:text-4xl lg:text-5xl">{title}</h1>
              {subtitle && (
                <h2 className="text-white m-0 text-xl lg:text-2xl opacity-60">{subtitle}</h2>
              )}
            </div>
          </div>
        )}
      </div>
      <GamesCategoryNav />
      {children}
    </div>
  );
};

export default ProviderGamesLayout;
